
class VideoToggle extends HTMLElement {
  initialized = false
  videoContainer
  videos

  constructor() {
    super();

    this.button = this.querySelector('button')
    this.onClick = this.toggle.bind(this)
  }

  connectedCallback() {
    this.init()

    const mediaHandlers = this.closest('ambient-media, deferred-media, [data-video-container]')
    mediaHandlers.addEventListener('loadContent', () => {
      this.initialized = false
      this.init()
    })
  }

  disconnectedCallback() {
    this.destroy()
  }

  init() {
    if (this.initialized) return

    console.log('VideoToggle init')

    const ariaControls = this.button.getAttribute('aria-controls')
    this.videos = ariaControls ?
      ariaControls.split(' ').map(id => document.getElementById(id)) :
      [...this.closest('ambient-media, deferred-media, [data-video-container]')?.querySelectorAll('video') ?? []]

    if (!this.videos.length) return

    if (!this.hasAttribute('play-state')) {
      window.addEventListener('load', () => {
        this.playState = this.videos[0].paused ? 'paused' : 'playing'
      })
    }

    this.button.addEventListener('click', this.onClick)

    this.initialized = true

  }

  destroy() {
    if (!this.initialized) return

    this.button.removeEventListener('click', this.onClick)
    this.initialized = false
  }

  get playState() {
    return this.getAttribute('play-state')
  }

  set playState(value) {
    this.setAttribute('play-state', value)
  }

  play() {
    this.setPlayState(true)

    this.videos.forEach(video => {
      video.play()
    })
  }

  pause() {
    this.setPlayState(false)

    this.videos.forEach(video => {
      video.pause()
    })
  }

  setPlayState(value = true) {
    this.playState = value ? 'playing' : 'paused'
    this.updateAriaLabel()
  }

  updateAriaLabel() {
    this.button.setAttribute('aria-label', this.playState === 'playing' ? window.accessibilityStrings.pauseVideo : window.accessibilityStrings.playVideo)
  }

  get isPlaying() {
    return this.videos.some(video => !video.paused)
  }

  toggle() {
    this.isPlaying ? this.pause() : this.play()
  }

  togglePlayState() {
    this.setPlayState(!this.isPlaying)
  }
}

customElements.define('video-toggle', VideoToggle)